// extracted by mini-css-extract-plugin
module.exports = {"circleContainer":"GalleryCircle_circleContainer__1l7RE","image":"GalleryCircle_image__3oNWd","content":"GalleryCircle_content__1Sey_","title":"GalleryCircle_title__3xFS_"};